export default "__VITE_ASSET__Dp222$pv__"